import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'wouter';

/** Hook to preserve scroll position for the #root-scroll element on a given page. */
export function useScrollRestoration() {
  const [location] = useLocation();

  useLayoutEffect(() => {
    const storedPositionSessionKey = `scroll:${location}`;
    const storedPosition = sessionStorage.getItem(storedPositionSessionKey);

    if (!storedPosition) {
      document.getElementById('root-scroll')?.scrollTo(0, 0);
      return;
    }

    if (storedPosition) {
      const { x, y } = JSON.parse(storedPosition);
      document.getElementById('root-scroll')?.scrollTo(x, y);
    }
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      sessionStorage.setItem(
        `scroll:${location}`,
        JSON.stringify({
          x: document.getElementById('root-scroll')?.scrollLeft || 0,
          y: document.getElementById('root-scroll')?.scrollTop || 0,
        }),
      );
    };
    document.getElementById('root-scroll')?.addEventListener('scroll', handleScroll);
    return () => {
      document.getElementById('root-scroll')?.removeEventListener('scroll', handleScroll);
    };
  }, [location]);
  return null;
}
